import apiClient from './apiClient.ts';

export interface YoutubeData {
  categories: { id: string; name: string }[] | null;
  playlists: { id: string; name: string }[];
  playlistsNextPageToken: string | null;
}

export async function getAllYoutubeData(
  pageToken?: string | null,
  includeCategories: boolean = true
): Promise<YoutubeData> {
  const params: { page_token?: string; include_categories?: boolean } = {};
  
  if (pageToken) {
    params.page_token = pageToken;
  }
  
  if (!includeCategories) {
    params.include_categories = false;
  }
  
  const response = await apiClient.get('/youtube/data', { params });
  
  // Handle nested structure: response.data.data.categories.categories
  const categoriesData = response.data.data.categories;
  const playlistsData = response.data.data.playlists;
  
  return {
    categories: categoriesData?.categories || null,
    playlists: playlistsData.playlists,
    playlistsNextPageToken: playlistsData.nextPageToken ?? null,
  };
}

// DEPRECATED: Use getAllYoutubeData with pageToken parameter instead
export const getPlaylists = async (pageToken?: string | null): Promise<{ playlists: { id: string; name: string }[]; nextPageToken: string | null }> => {
  // Use the consolidated endpoint with include_categories=false
  const data = await getAllYoutubeData(pageToken, false);
  
  return {
    playlists: data.playlists,
    nextPageToken: data.playlistsNextPageToken,
  };
};
